














































import Vue from "vue";
import blogPostsData from "@/data/BlogPostsData.ts";

export default Vue.extend({
  name: "GameProjects",
  components: {
  },
  data: function () {
    return {
      blogPost: blogPostsData[0],
    };
  },
});
